import { useEffect } from 'react';
import { useAppSettings } from '../context/AppSettingsContext';
import { applyFavicon, applyPageTitle } from '../utils/applyFavicon';
import { buildImageUrl } from '../utils/imageUrl';

export const useFavicon = () => {
  const { settings, imageBaseUrl } = useAppSettings();  // ✅ API se

  useEffect(() => {
    if (!settings?.general) return;

    if (settings.general.favicon) {
      const url = buildImageUrl(settings.general.favicon, imageBaseUrl);  // ✅ API
      applyFavicon(url);
    }

    if (settings.general.storeName) {
      applyPageTitle(settings.general.storeName);
    }
  }, [settings, imageBaseUrl]);
};